@if (!accountingOperations || accountingOperations?.length < 1) {
	<div class="alert alert-warning d-flex align-items-center p-4" role="alert">
		<div class="text-center">No Accounting Operations Found.</div>
	</div>
} @else {
	<div class="fade-in">
		<div ngbAccordion #accordion="ngbAccordion">
			@for (acctOp of accountingOperations; track acctOp.id) {
				<div ngbAccordionItem="{{ acctOp.id }}" [collapsed]="false" #item="ngbAccordionItem">
					<div ngbAccordionHeader aria-level="2">
						<div class="position-relative accounting-operation">
							<button ngbAccordionButton
								class="accordion-button panel__title d-flex justify-content-between align-items-center"
								[ngClass]="{'collapsed' : !accordion.isExpanded}"
								[attr.data-cy]="'toggleAccordion'+ acctOp.id">
								<div class="cursor-pointer d-flex align-items-center">
									<h6 class="h5 py-1 mb-0">
										{{acctOp.operationName}}
									</h6>
									<span class="text-small ps-3 ms-3 border-start">
										Revenue Allocation Template: <strong>{{ getTemplateName(acctOp.anchorTemplateId)
										}}</strong>
									</span>
									@if (acctOp.costAnchorTemplateId > 0) {
										<span class="text-small ps-3 ms-3 border-start">
											Cost Allocation Template: <strong>{{ getTemplateName(acctOp.costAnchorTemplateId)
										}}</strong>
										</span>
									}
									<span class="text-small ps-3 ms-3 border-start">
										Operation Type: <strong>{{ getOperationType(acctOp.operationType)
										}}</strong>
									</span>
								</div>
								<i class="fal fa-chevron-right cursor-pointer toggle-chevron p-1"
									[title]="accordion.isExpanded(acctOp.id) ? 'Collapse' : 'Expand'"
									[attr.data-cy]="accordion.isExpanded(acctOp.id) ? 'ToCollapse' : 'ToExpand'"
									[class.open]="accordion.isExpanded(acctOp.id)">
								</i>
							</button>
							<span class="panel__ops position-absolute accounting-operation__panel d-inline-block">
								<span class="d-inline-block ms-3 text-center" data-cy="ExpandCollapseArrow">
									@if (!editMode && !isArchived && !hasContractAdjustments) {
										<span class="accounting-operation__buttons">
											<button class="btn btn-icon py-0 me-2" title="Edit Operation" role="button"
												(click)="editOperation(acctOp)"
												[attr.data-cy]="'editOperation'+ acctOp.id">
												<i class="fal fa-pencil"></i>
											</button>
											<button class="btn btn-icon me-4" title="Delete Operation" role="button"
												(click)="deleteOperation(deleteAccountingOperationPrompt, acctOp)"
												[disabled]="deletingOperations.has(acctOp.id)"
												[attr.data-cy]="'deleteOperation'+ acctOp.id">
												<i class="fal fa-trash-can"></i>
											</button>
										</span>
									}
								</span>
							</span>
						</div>
					</div>
					<div ngbAccordionCollapse>
						<div ngbAccordionBody class="p-0">
							<ng-template>
								@if (editMode) {
									<rl-ff-build-accounting-operation [accountingProcessId]="accountingProcess.id"
										[accountingProcess]="accountingProcess" [operation]="acctOp"
										[accounts]="accounts" [accountGroups]="accountGroups"
										[openPanels]="openPanelIds.includes(acctOp.id)"
										(onSave)="operationSaved($event)" class="d-block m-3">
									</rl-ff-build-accounting-operation>
								} @else {
									<rl-ff-account-operation [accountingOperation]="acctOp"
										[operationType]="acctOp.operationType" class="d-block m-3">
									</rl-ff-account-operation>
								}
							</ng-template>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
}


<ng-template #deleteAccountingOperationPrompt let-prompt="prompt">
	<div>
		<p>Are you sure you want to delete the {{ prompt.context.operation.operationName }} Accounting Operation?
		</p>
	</div>
	<div class="text-end mt-3 w-100">
		<button class="btn btn-light btn-sm" (click)="prompt.onConfirm.next(false)" data-cy="deleteNo">Cancel</button>
		<button class="btn btn-success btn-sm ms-2" (click)="prompt.onConfirm.next(true)"
			data-cy="deleteYes">Delete</button>
	</div>
</ng-template>